export const AIRPORTS = [
  "Atlanta Hartsfield-Jackson International Airport (ATL) - Atlanta, USA",
  "Beijing Capital International Airport (PEK) - Beijing, China",
  "Dubai International Airport (DXB) - Dubai, UAE",
  "Tokyo Haneda Airport (HND) - Tokyo, Japan",
  "Los Angeles International Airport (LAX) - Los Angeles, USA",
  "London Heathrow Airport (LHR) - London, United Kingdom",
  "Chicago O'Hare International Airport (ORD) - Chicago, USA",
  "Paris Charles de Gaulle Airport (CDG) - Paris, France",
  "Amsterdam Schiphol Airport (AMS) - Amsterdam, Netherlands",
  "Tokyo Narita Airport (NRT) - Tokyo, Japan",
  "Guangzhou Baiyun International Airport (CAN) - Guangzhou, China",
  "Frankfurt Airport (FRA) - Frankfurt, Germany",
  "Istanbul Airport (IST) - Istanbul, Turkey",
  "Denver International Airport (DEN) - Denver, USA",
  "Singapore Changi Airport (SIN) - Singapore",
  "Seoul Incheon International Airport (ICN) - Seoul, South Korea",
  "New York John F. Kennedy International Airport (JFK) - New York, USA",
  "Dallas/Fort Worth International Airport (DFW) - Dallas, USA",
  "Shanghai Pudong International Airport (PVG) - Shanghai, China",
  "Charlotte Douglas International Airport (CLT) - Charlotte, USA",
  "Las Vegas Harry Reid International Airport (LAS) - Las Vegas, USA",
  "Phoenix Sky Harbor International Airport (PHX) - Phoenix, USA",
  "Miami International Airport (MIA) - Miami, USA",
  "Seattle-Tacoma International Airport (SEA) - Seattle, USA",
  "Orlando International Airport (MCO) - Orlando, USA",
  "Toronto Pearson International Airport (YYZ) - Toronto, Canada",
  "Munich Airport (MUC) - Munich, Germany",
  "Madrid Barajas Airport (MAD) - Madrid, Spain",
  "Barcelona El Prat Airport (BCN) - Barcelona, Spain",
  "Sydney Kingsford Smith Airport (SYD) - Sydney, Australia",
  "Houston George Bush Intercontinental Airport (IAH) - Houston, USA",
  "San Francisco International Airport (SFO) - San Francisco, USA",
  "London Gatwick Airport (LGW) - London, United Kingdom",
  "Doha Hamad International Airport (DOH) - Doha, Qatar",
  "Moscow Sheremetyevo Airport (SVO) - Moscow, Russia",
  "Bangkok Suvarnabhumi Airport (BKK) - Bangkok, Thailand",
  "Kuala Lumpur International Airport (KUL) - Kuala Lumpur, Malaysia",
  "Jakarta Soekarno-Hatta Airport (CGK) - Jakarta, Indonesia",
  "Johannesburg OR Tambo International Airport (JNB) - Johannesburg, South Africa",
  "Delhi Indira Gandhi Airport (DEL) - Delhi, India",
  "Mumbai Chhatrapati Shivaji Airport (BOM) - Mumbai, India",
  "Hong Kong International Airport (HKG) - Hong Kong",
  "Auckland International Airport (AKL) - Auckland, New Zealand",
  "Melbourne Airport (MEL) - Melbourne, Australia",
  "Brisbane Airport (BNE) - Brisbane, Australia",
  "Vancouver International Airport (YVR) - Vancouver, Canada",
  "Montreal Trudeau Airport (YUL) - Montreal, Canada",
  "Riyadh King Khalid Airport (RUH) - Riyadh, Saudi Arabia",
  "Jeddah King Abdulaziz Airport (JED) - Jeddah, Saudi Arabia",
  "Abu Dhabi International Airport (AUH) - Abu Dhabi, UAE",
  "Manila Ninoy Aquino Airport (MNL) - Manila, Philippines",
  "Taipei Taoyuan Airport (TPE) - Taipei, Taiwan",
  "Hanoi Noi Bai Airport (HAN) - Hanoi, Vietnam",
  "Ho Chi Minh City Tan Son Nhat Airport (SGN) - Ho Chi Minh, Vietnam",
  "Doha Hamad International Airport (DOH) - Doha, Qatar",
  "Oslo Gardermoen Airport (OSL) - Oslo, Norway",
  "Stockholm Arlanda Airport (ARN) - Stockholm, Sweden",
  "Copenhagen Airport (CPH) - Copenhagen, Denmark",
  "Zurich Airport (ZRH) - Zurich, Switzerland",
  "Vienna International Airport (VIE) - Vienna, Austria",
  "Dublin Airport (DUB) - Dublin, Ireland",
  "Brussels Airport (BRU) - Brussels, Belgium",
  "Geneva Airport (GVA) - Geneva, Switzerland",
  "Lisbon Humberto Delgado Airport (LIS) - Lisbon, Portugal",
  "Athens Eleftherios Venizelos Airport (ATH) - Athens, Greece",
  "Reykjavik Keflavik Airport (KEF) - Reykjavik, Iceland",
  "Helsinki Vantaa Airport (HEL) - Helsinki, Finland",
  "Bucharest Henri Coandă Airport (OTP) - Bucharest, Romania",
  "Warsaw Chopin Airport (WAW) - Warsaw, Poland",
  "Budapest Ferenc Liszt Airport (BUD) - Budapest, Hungary",
  "Prague Václav Havel Airport (PRG) - Prague, Czech Republic",
  "Belgrade Nikola Tesla Airport (BEG) - Belgrade, Serbia",
  "Sofia International Airport (SOF) - Sofia, Bulgaria",
  "Zagreb Franjo Tuđman Airport (ZAG) - Zagreb, Croatia",
  "Split Airport (SPU) - Split, Croatia",
  "Dubrovnik Airport (DBV) - Dubrovnik, Croatia",
  "Ljubljana Jože Pučnik Airport (LJU) - Ljubljana, Slovenia",
  "Vienna International Airport (VIE) - Vienna, Austria",
  "Edinburgh Airport (EDI) - Edinburgh, United Kingdom",
  "Manchester Airport (MAN) - Manchester, United Kingdom",
  "Birmingham Airport (BHX) - Birmingham, United Kingdom",
  "Glasgow Airport (GLA) - Glasgow, United Kingdom",
  "Newcastle Airport (NCL) - Newcastle, United Kingdom",
  "Bristol Airport (BRS) - Bristol, United Kingdom",
  "Leeds Bradford Airport (LBA) - Leeds, United Kingdom",
  "Cardiff Airport (CWL) - Cardiff, United Kingdom",
  "Liverpool John Lennon Airport (LPL) - Liverpool, United Kingdom",
  "London Stansted Airport (STN) - London, United Kingdom",
  "London Luton Airport (LTN) - London, United Kingdom",
  "Paris Orly Airport (ORY) - Paris, France",
  "Lyon Saint-Exupéry Airport (LYS) - Lyon, France",
  "Nice Côte d'Azur Airport (NCE) - Nice, France",
  "Toulouse-Blagnac Airport (TLS) - Toulouse, France",
  "Marseille Provence Airport (MRS) - Marseille, France",
  "Bordeaux-Mérignac Airport (BOD) - Bordeaux, France",
  "Basel-Mulhouse-Freiburg Airport (BSL) - Basel, Switzerland",
  "Berlin Brandenburg Airport (BER) - Berlin, Germany",
  "Hamburg Airport (HAM) - Hamburg, Germany",
  "Düsseldorf Airport (DUS) - Düsseldorf, Germany",
  "Stuttgart Airport (STR) - Stuttgart, Germany",
  "Cologne Bonn Airport (CGN) - Cologne, Germany",
  "Hannover Airport (HAJ) - Hannover, Germany",
  "Nuremberg Airport (NUE) - Nuremberg, Germany",
  "Leipzig/Halle Airport (LEJ) - Leipzig, Germany",
  "Munich Airport (MUC) - Munich, Germany",
  "Frankfurt Hahn Airport (HHN) - Frankfurt, Germany",
  "Barcelona Girona Airport (GRO) - Girona, Spain",
  "Valencia Airport (VLC) - Valencia, Spain",
  "Bilbao Airport (BIO) - Bilbao, Spain",
  "Seville Airport (SVQ) - Seville, Spain",
  "Málaga Costa del Sol Airport (AGP) - Málaga, Spain",
  "Ibiza Airport (IBZ) - Ibiza, Spain",
  "Mallorca Palma Airport (PMI) - Palma, Spain",
  "Menorca Airport (MAH) - Menorca, Spain",
  "Gran Canaria Airport (LPA) - Gran Canaria, Spain",
  "Tenerife South Airport (TFS) - Tenerife, Spain",
  "Tenerife North Airport (TFN) - Tenerife, Spain",
  "Lanzarote Airport (ACE) - Lanzarote, Spain",
  "Fuerteventura Airport (FUE) - Fuerteventura, Spain",
  "Porto Francisco Sá Carneiro Airport (OPO) - Porto, Portugal",
  "Faro Airport (FAO) - Faro, Portugal",
  "Madeira Cristiano Ronaldo Airport (FNC) - Madeira, Portugal",
  "Ponta Delgada Airport (PDL) - Azores, Portugal",
  "New York LaGuardia Airport (LGA) - New York, USA",
  "Newark Liberty International Airport (EWR) - Newark, USA",
  "Boston Logan International Airport (BOS) - Boston, USA",
  "Philadelphia International Airport (PHL) - Philadelphia, USA",
  "Washington Dulles International Airport (IAD) - Washington, USA",
  "Washington Ronald Reagan Airport (DCA) - Washington, USA",
  "Detroit Metropolitan Airport (DTW) - Detroit, USA",
  "Minneapolis-Saint Paul Airport (MSP) - Minneapolis, USA",
  "Salt Lake City International Airport (SLC) - Salt Lake City, USA",
  "Portland International Airport (PDX) - Portland, USA",
  "San Diego International Airport (SAN) - San Diego, USA",
  "San Jose International Airport (SJC) - San Jose, USA",
  "Sacramento International Airport (SMF) - Sacramento, USA",
  "Raleigh-Durham International Airport (RDU) - Raleigh, USA",
  "Nashville International Airport (BNA) - Nashville, USA",
  "New Orleans Louis Armstrong Airport (MSY) - New Orleans, USA",
  "Tampa International Airport (TPA) - Tampa, USA",
  "Orlando Sanford Airport (SFB) - Orlando, USA",
  "Fort Lauderdale-Hollywood Airport (FLL) - Fort Lauderdale, USA",
  "Charlotte Douglas Airport (CLT) - Charlotte, USA",
  "Anchorage Ted Stevens Airport (ANC) - Anchorage, USA",
  "Honolulu Daniel K. Inouye Airport (HNL) - Honolulu, USA",
  "Mexico City International Airport (MEX) - Mexico City, Mexico",
  "Cancún International Airport (CUN) - Cancún, Mexico",
  "Guadalajara International Airport (GDL) - Guadalajara, Mexico",
  "Monterrey International Airport (MTY) - Monterrey, Mexico",
  "Bogotá El Dorado Airport (BOG) - Bogotá, Colombia",
  "Medellín José María Córdova Airport (MDE) - Medellín, Colombia",
  "Cartagena Rafael Núñez Airport (CTG) - Cartagena, Colombia",
  "Quito Mariscal Sucre Airport (UIO) - Quito, Ecuador",
  "Lima Jorge Chávez Airport (LIM) - Lima, Peru",
  "Santiago Arturo Merino Benítez Airport (SCL) - Santiago, Chile",
  "Buenos Aires Ezeiza Airport (EZE) - Buenos Aires, Argentina",
  "Buenos Aires Aeroparque Airport (AEP) - Buenos Aires, Argentina",
  "São Paulo Guarulhos Airport (GRU) - São Paulo, Brazil",
  "São Paulo Congonhas Airport (CGH) - São Paulo, Brazil",
  "Rio de Janeiro Galeão Airport (GIG) - Rio de Janeiro, Brazil",
  "Brasília International Airport (BSB) - Brasília, Brazil",
  "Salvador Deputado Luís Eduardo Magalhães Airport (SSA) - Salvador, Brazil",
  "Recife Guararapes Airport (REC) - Recife, Brazil",
  "Porto Alegre Airport (POA) - Porto Alegre, Brazil",
  "Windhoek Hosea Kutako Airport (WDH) - Windhoek, Namibia",
  "Cape Town International Airport (CPT) - Cape Town, South Africa",
  "Durban King Shaka Airport (DUR) - Durban, South Africa",
  "Cairo International Airport (CAI) - Cairo, Egypt",
  "Casablanca Mohammed V Airport (CMN) - Casablanca, Morocco",
  "Marrakech Menara Airport (RAK) - Marrakech, Morocco",
  "Agadir-Al Massira Airport (AGA) - Agadir, Morocco",
  "Tunis Carthage Airport (TUN) - Tunis, Tunisia",
  "Algiers Houari Boumediene Airport (ALG) - Algiers, Algeria",
  "Accra Kotoka Airport (ACC) - Accra, Ghana",
  "Lagos Murtala Muhammed Airport (LOS) - Lagos, Nigeria",
  "Addis Ababa Bole Airport (ADD) - Addis Ababa, Ethiopia",
  "Nairobi Jomo Kenyatta Airport (NBO) - Nairobi, Kenya",
  "Dar es Salaam Julius Nyerere Airport (DAR) - Dar es Salaam, Tanzania",
  "Maputo International Airport (MPM) - Maputo, Mozambique",
  "Abuja Nnamdi Azikiwe Airport (ABV) - Abuja, Nigeria",
  "Harare Robert Gabriel Mugabe Airport (HRE) - Harare, Zimbabwe",
  "Doha Hamad Airport (DOH) - Doha, Qatar",
  "Muscat International Airport (MCT) - Muscat, Oman",
  "Kuwait International Airport (KWI) - Kuwait City, Kuwait",
  "Tehran Imam Khomeini Airport (IKA) - Tehran, Iran",
  "Karachi Jinnah Airport (KHI) - Karachi, Pakistan",
  "Lahore Allama Iqbal Airport (LHE) - Lahore, Pakistan",
  "Islamabad International Airport (ISB) - Islamabad, Pakistan",
  "Dhaka Hazrat Shahjalal Airport (DAC) - Dhaka, Bangladesh",
  "Colombo Bandaranaike Airport (CMB) - Colombo, Sri Lanka",
  "Nepal Tribhuvan Airport (KTM) - Kathmandu, Nepal",
  "Male Velana International Airport (MLE) - Maldives",
  "Kathmandu Tribhuvan Airport (KTM) - Kathmandu, Nepal",
  "Brunei International Airport (BWN) - Bandar Seri Begawan, Brunei",
  "Yangon International Airport (RGN) - Yangon, Myanmar",
  "Hong Kong Chek Lap Kok Airport (HKG) - Hong Kong",
  "Macau International Airport (MFM) - Macau, China",
  "Ulaanbaatar Chinggis Khaan Airport (UBN) - Ulaanbaatar, Mongolia",
  "Hanoi Noi Bai Airport (HAN) - Hanoi, Vietnam",
  "Phnom Penh International Airport (PNH) - Phnom Penh, Cambodia",
  "Siem Reap International Airport (REP) - Siem Reap, Cambodia",
  "Bangkok Don Mueang Airport (DMK) - Bangkok, Thailand",
  "Krakow John Paul II Airport (KRK) - Krakow, Poland",
  "Gdańsk Lech Wałęsa Airport (GDN) - Gdańsk, Poland",
  "Wrocław Copernicus Airport (WRO) - Wrocław, Poland",
  "Riga International Airport (RIX) - Riga, Latvia",
  "Vilnius International Airport (VNO) - Vilnius, Lithuania",
  "Kaunas Airport (KUN) - Kaunas, Lithuania",
  "Tallinn Lennart Meri Airport (TLL) - Tallinn, Estonia",
  "Kiev Boryspil Airport (KBP) - Kiev, Ukraine",
  "Lviv Danylo Halytskyi Airport (LWO) - Lviv, Ukraine",
  "Chisinau International Airport (KIV) - Chisinau, Moldova"
];

export const ITALIAN_AIRPORTS = [
  "Rome Fiumicino Airport (FCO) - Roma",
  "Rome Ciampino Airport (CIA) - Roma",
  "Milan Malpensa Airport (MXP) - Milano",
  "Milan Linate Airport (LIN) - Milano",
  "Bergamo Orio al Serio Airport (BGY) - Bergamo",
  "Venice Marco Polo Airport (VCE) - Venezia",
  "Treviso Antonio Canova Airport (TSF) - Treviso",
  "Turin Caselle Airport (TRN) - Torino",
  "Genoa Cristoforo Colombo Airport (GOA) - Genova",
  "Bologna Guglielmo Marconi Airport (BLQ) - Bologna",
  "Florence Amerigo Vespucci Airport (FLR) - Firenze",
  "Pisa Galileo Galilei Airport (PSA) - Pisa",
  "Naples Capodichino Airport (NAP) - Napoli",
  "Bari Karol Wojtyła Airport (BRI) - Bari",
  "Brindisi Salento Airport (BDS) - Brindisi",
  "Lamezia Terme Airport (SUF) - Lamezia Terme",
  "Reggio Calabria Airport (REG) - Reggio Calabria",
  "Catania Fontanarossa Airport (CTA) - Catania",
  "Palermo Falcone-Borsellino Airport (PMO) - Palermo",
  "Trapani Birgi Airport (TPS) - Trapani",
  "Comiso Airport (CIY) - Comiso",
  "Alghero Fertilia Airport (AHO) - Alghero",
  "Olbia Costa Smeralda Airport (OLB) - Olbia",
  "Cagliari Elmas Airport (CAG) - Cagliari",
  "Ancona Falconara Airport (AOI) - Ancona",
  "Perugia San Francesco d'Assisi Airport (PEG) - Perugia",
  "Trieste Airport (TRS) - Trieste",
  "Verona Villafranca Airport (VRN) - Verona",
  "Brescia Montichiari Airport (VBS) - Brescia",
  "Parma Airport (PMF) - Parma",
  "Bolzano Airport (BZO) - Bolzano",
  "Cuneo Levaldigi Airport (CUF) - Cuneo",
  "Pescara Abruzzo Airport (PSR) - Pescara",
  "Forlì Airport (FRL) - Forlì",
  "Pantelleria Airport (PNL) - Pantelleria",
  "Lampedusa Airport (LMP) - Lampedusa",
  "Aosta Airport (AOT) - Aosta (limitato)"
];

export const ALL_AIRPORTS = [...AIRPORTS, ...ITALIAN_AIRPORTS];

export const getAirports = () => ALL_AIRPORTS;

export const searchAirports = (query: string) => {
  if (!query) return ALL_AIRPORTS;

  return ALL_AIRPORTS.filter(airport =>
    airport.toLowerCase().includes(query.toLowerCase())
  );
};
